import React, { useState, useRef } from "react";
import { BsPuzzleFill } from "react-icons/bs";
import { Button } from "reactstrap";

const PopupMaterial = ({ isOpen, onClose }) => {
  const modalRef = useRef();

  const handleOutsideClick = (event) => {
    if (modalRef.current && !modalRef.current.contains(event.target)) {
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center z-50"
      onClick={handleOutsideClick}
    >
      <div
        ref={modalRef}
        className="bg-white text-center p-8 rounded shadow-md w-72"
      >
        <BsPuzzleFill className=" text-teal-500 mx-auto" size={41} />
        <h2 className="text-xl my-2">Wheel Excavator 21</h2>

        <span className="text-xs text-gray-400">Code:</span>
        <h6 className="mb-1 text-sm">OKGR0ZKHZJVKQMDO</h6>

        <span className="text-xs text-gray-400">Unit:</span>
        <h6 className="mb-1 text-sm">ml</h6>

        <span className="text-xs text-gray-400">Description:</span>
        <h6 className="mb-1 text-sm">Description eB</h6>

        <hr className="pb-4" />
        <Button
          color="primary"
          onClick={"openEditUpdateModel"}
          className="flex items-center bg-teal-500 text-white px-4 py-2 rounded-md mx-auto border-0 hover:bg-teal-600"
        >
          <BsPuzzleFill size={15} className="mr-2" />
          Edit
        </Button>
      </div>
    </div>
  );
};

export default PopupMaterial;
